// components/SuperPhilosophyTagline.jsx
// Single source of truth for the FHO "Super Philosophy" positioning line.
// Variants:
//   "consumer"    -> Hero, PlatformPage hero (bold, aspirational)
//   "partnership" -> 13 partner pages + partnerships section (plainer, concrete)
//   "arc"         -> ARC page only (grounded, conceptual)
// Outcome words inherit the surrounding paragraph color; bold carries the emphasis.

import React from 'react';


const SuperPhilosophyTagline = ({ variant = 'consumer', align = 'center', color = '#1e3a5f', style = {} }) => {
  const F = <span style={{ color: 'inherit', fontWeight: 700 }}>Freedom</span>;
  const H = <span style={{ color: 'inherit', fontWeight: 700 }}>Happiness</span>;
  const O = <span style={{ color: 'inherit', fontWeight: 700 }}>Oneness</span>;

  const lead = { fontSize: 'clamp(11px, 1.4vw, 13px)', letterSpacing: '0.16em', textTransform: 'uppercase', fontWeight: 700, opacity: 0.72, marginBottom: '8px', color };
  const line = { fontSize: variant === 'consumer' ? 'clamp(18px, 2.4vw, 24px)' : 'clamp(16px, 2vw, 20px)', fontWeight: 600, lineHeight: 1.4, color, margin: 0 };
  const wrap = { textAlign: align, maxWidth: '760px', margin: align === 'center' ? '0 auto' : '0', ...style };

  let body;
  if (variant === 'consumer') {
    body = <>The first Super Philosophy for your personal path to {F}, {H}, and {O}.</>;
  } else if (variant === 'arc') {
    body = <>A structured path to {F}, {H}, and {O} — the individual-formation layer beneath the outcomes you serve.</>;
  } else {
    body = <>A structured path to {F}, {H}, and {O} that you extend to the people you serve.</>;
  }

  return (
    <div style={wrap}>
      <div style={lead}>Fhoism · The FHO Methodology</div>
      <p style={line}>{body}</p>
    </div>
  );
};

export default SuperPhilosophyTagline;
